import React from 'react';
import { View, StyleSheet, ScrollView, ActivityIndicator } from 'react-native';
import { Subtitle, Paragraph } from '../../../components';
import { useLanguage } from '../../../locale';
import { MainKpiScore } from '../../../api/survey/kpi.models';
import { KpiGaugeChart } from './KpiGaugeChart';
import { Config } from '../../../config';

interface KpiScoresSectionProps {
  kpiScores: MainKpiScore[];
  isLoading: boolean;
}

export const KpiScoresSection: React.FC<KpiScoresSectionProps> = ({
  kpiScores,
  isLoading,
}) => {
  const [t] = useLanguage();

  if (isLoading) {
    return (
      <View style={styles.container}>
        <Subtitle>{t('stats.kpiScores')}</Subtitle>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={Config.colorPrimary} />
        </View>
      </View>
    );
  }

  if (!kpiScores || kpiScores.length === 0) {
    return (
      <View style={styles.container}>
        <Subtitle>{t('stats.kpiScores')}</Subtitle>
        <View style={styles.emptyContainer}>
          <Paragraph style={styles.emptyText}>{t('stats.noKpiData')}</Paragraph>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Subtitle>{t('stats.kpiScores')}</Subtitle>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.scrollContent}
      >
        {kpiScores
          .flatMap((mainKpi) => mainKpi.specificKpiScores)
          .sort((a, b) => b.score - a.score)
          .map((kpi) => (
            <KpiGaugeChart
              key={kpi.id}
              title={kpi.title}
              score={kpi.score}
              maxScore={4}
            />
          ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    // marginTop: 24,
    marginBottom: 16,
  },
  progressContainer: {
    marginTop: 8,
    marginBottom: 8,
  },
  progressText: {
    color: Config.colorTextSecondary,
  },
  scrollContent: {
    paddingVertical: 16,
    paddingHorizontal: 8,
    flexDirection: 'row',
  },
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    marginTop: 16,
  },
  emptyText: {
    color: Config.colorTextSecondary,
    textAlign: 'center',
  },
});
